"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VerifyActionDto = exports.GetPermissionGroupsOptionsDto = exports.UpdateRolePermissionGroupsDto = exports.PermissionGroupDto = exports.BatchCreatePermissionGroupDto = exports.CreatePermissionGroupDto = void 0;
const general_dto_1 = require("../../dto/general.dto");
class CreatePermissionGroupDto {
    constructor() {
        this.active = true;
    }
}
exports.CreatePermissionGroupDto = CreatePermissionGroupDto;
class BatchCreatePermissionGroupDto {
}
exports.BatchCreatePermissionGroupDto = BatchCreatePermissionGroupDto;
class PermissionGroupDto extends CreatePermissionGroupDto {
}
exports.PermissionGroupDto = PermissionGroupDto;
class UpdateRolePermissionGroupsDto {
}
exports.UpdateRolePermissionGroupsDto = UpdateRolePermissionGroupsDto;
class GetPermissionGroupsOptionsDto extends general_dto_1.PaginatedSearchDto {
    constructor() {
        super(...arguments);
        this.includeInactive = false;
        this.includePermissions = false;
        this.includeChildGroups = false;
    }
}
exports.GetPermissionGroupsOptionsDto = GetPermissionGroupsOptionsDto;
class VerifyActionDto {
    constructor() {
        this.areYouSure = false;
    }
}
exports.VerifyActionDto = VerifyActionDto;
//# sourceMappingURL=permission-group.dto.js.map